import { Component } from '@angular/core'
import { SpinnerComponent } from '../../spinner/spinner.component'
import type { ILoadingOverlayAngularComp } from 'ag-grid-angular'
import type { ILoadingOverlayParams } from 'ag-grid-community'

@Component({
  imports: [SpinnerComponent],
  selector: 'app-table-overlay-component',
  template: '<app-spinner/>',
})
export class TableLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  agInit(params: ILoadingOverlayParams): void {
    this.refresh(params)
  }
    
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  refresh(params: ILoadingOverlayParams): void {
    /* empty */
  }
}